import { useEffect, useState } from 'react'

interface JsonViewProps<T> {
  value: T
  onChange: (next: T) => void
}

export function JsonView<T>({ value, onChange }: JsonViewProps<T>) {
  const [text, setText] = useState(() => JSON.stringify(value, null, 2))
  const [error, setError] = useState<string | undefined>()

  useEffect(() => {
    setText(JSON.stringify(value, null, 2))
  }, [value])

  const commit = (next: string) => {
    setText(next)
    try {
      const parsed = JSON.parse(next)
      onChange(parsed as T)
      setError(undefined)
    } catch (e) {
      setError(e instanceof Error ? e.message : 'Invalid JSON')
    }
  }

  return (
    <div className="space-y-1">
      <div className="flex items-center justify-between">
        <h3 className="text-[11px] font-semibold uppercase tracking-wide text-stone-500">
          JSON view
        </h3>
        {error && (
          <span className="text-[11px] text-rose-600">{error}</span>
        )}
      </div>
      <textarea
        value={text}
        onChange={e => commit(e.target.value)}
        spellCheck={false}
        rows={12}
        className="w-full rounded border border-stone-300 bg-white px-2 py-1 font-mono text-[11px] text-stone-900 dark:border-stone-700 dark:bg-stone-950 dark:text-stone-100"
      />
    </div>
  )
}
